export enum EnumTypeTables {
    operators = 'Operadores',
    suppliers = 'Fornecedores',
    staff = 'Staff'
}
